import { ADD_PREDICTION_LEVEL, ADD_PREDICTION_LEVEL_ERROR, ADD_PREDICTION_LEVEL_SUCCESS, DELETE_PREDICTION_LEVEL, DELETE_PREDICTION_LEVEL_ERROR, DELETE_PREDICTION_LEVEL_SUCCESS,  PREDICTION_LEVEL_DETAILS, PREDICTION_LEVEL_DETAILS_ERROR, PREDICTION_LEVEL_DETAILS_SUCCESS, PREDICTION_LEVEL_LIST, PREDICTION_LEVEL_LIST_ERROR, PREDICTION_LEVEL_LIST_SUCCESS, PREDICTION_LEVEL_UPDATE, PREDICTION_LEVEL_UPDATE_ERROR, PREDICTION_LEVEL_UPDATE_SUCCESS} from './constants';



export default function PredicitonlevelManagementReducer(state, action) {


	let predictionlevel = [];
    
	switch (action.type) {
	case PREDICTION_LEVEL_LIST:
		return {...state, loading: true, error : false};
	case PREDICTION_LEVEL_LIST_SUCCESS : 
		
        
		if (action.payload && action.payload && action.payload.length > 0) {
			action.payload.map( (item) => {
				let data = {};                        
				data.id = item.id ? item.id : 0;
				data.name = item.name;
				return predictionlevel.push(data);
			});       
			return { ...state, predictionlevel:predictionlevel ,loading: false, error: false };
		} else {
			if (action.payload && action.payload && action.payload.length === 0) {
				return { ...state, predictionlevel : [] , loading: false, error: false };
			} else {
				return { ...state , loading: false, error: true };
			}
		}
	case PREDICTION_LEVEL_LIST_ERROR : 
		return { ...state, loading : false, error : true };

	case ADD_PREDICTION_LEVEL:
		return {...state, loading : true, error : false };
	case ADD_PREDICTION_LEVEL_SUCCESS:
		return {...state, false : true, error : false , };

	case ADD_PREDICTION_LEVEL_ERROR:
		return {...state, loading : false, error : true };

	case PREDICTION_LEVEL_DETAILS:
		return { ...state, pending: true };
			
	case PREDICTION_LEVEL_DETAILS_SUCCESS:
	
		return { ...state, pending: false, details:action.payload, error: false };
	case PREDICTION_LEVEL_DETAILS_ERROR:
		return { ...state, pending: false, error: true };

	case PREDICTION_LEVEL_UPDATE:
		return { ...state, pending: false };
	case PREDICTION_LEVEL_UPDATE_SUCCESS:
		return { ...state, pending: false, error: false };
	case PREDICTION_LEVEL_UPDATE_ERROR:
		return { ...state, pending: false, error: true }; 
	case DELETE_PREDICTION_LEVEL:
		return { ...state, pending: false };
		
	case DELETE_PREDICTION_LEVEL_SUCCESS:
		return { ...state, pending: false, error: false };
		
	case DELETE_PREDICTION_LEVEL_ERROR:
		return { ...state, pending: false, error: true };
	default: {
		throw Error('Unknown action: ' + action.type);
	}
	}
}